export const SIGNATURESTATEMENTMANAGEMENT_FILE = 'SIGNATURESTATEMENTMANAGEMENT_FILE';
// 更新
export const SIGNATURESTATEMENTMANAGEMENT_UPDATE = 'SIGNATURESTATEMENTMANAGEMENT_UPDATE';
